import React, { useEffect, useState } from "react";
import './AdminConsole.css';
import API from '../../API';
import { useAuth0 } from "@auth0/auth0-react";
import AppHeader from "../AppHeader";
import EditServerInfo from "./EditServerInfo";
import EditEvent from "./EditEvent";

const AdminConsole = ({ wallets, setWallets }) => {
    const [serverInfos, setServerInfos] = useState([]);
    const [events, setEvents] = useState([]);
    const [accessToken, setAccessToken] = useState(null);
    const { isAuthenticated, isLoading, getAccessTokenSilently } = useAuth0();
    useEffect(() => {
        async function getEvents() {
            if (isAuthenticated) {
                const accessToken = await getAccessTokenSilently({
                    audience: process.env.REACT_APP_AUTH0_AUDIENCE,
                    scope: "ffclient:play",
                });
                setAccessToken(accessToken);

                const response = await API.adminGetEvents(accessToken);
                if (response.status !== 200) {
                    console.log("Error getting events.");
                    return;
                }

                const data = await response.json();
                setEvents(data.events);

                const serverInfosResponse = await API.adminGetServerInfos(accessToken);
                if (serverInfosResponse.status !== 200) {
                    console.log("Error getting room.");
                    return;
                }

                const serverInfosData = await serverInfosResponse.json();
                setServerInfos(serverInfosData);
            }
        };
        getEvents();
    }, [getAccessTokenSilently, isAuthenticated]);

    if (isLoading) {
        return <div>Loading ...</div>;
    }

    return ( isAuthenticated &&
        <div>
            <AppHeader wallets={wallets} setWallets={setWallets} />
            <div className="admin-content">
                <h1 className="customization-title">Admin</h1>
                <div className="panel">
                    <h2>Server Info</h2>
                    { serverInfos.map(room => 
                        <EditServerInfo room={room} accessToken={accessToken} key={room.room_id} />
                    )}
                </div>
                <div className="panel">
                    <h2>Active events</h2>
                    { events.map(event =>
                        <EditEvent event={event} accessToken={accessToken} key={event.id} />
                    ) }
                </div>
            </div>
        </div>
    );
};

export default AdminConsole;
